import React from 'react';
import Picture, { PictureProps } from '@soluto-design/picture';
import { Text, Title } from '@soluto-design/react';
import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardIconProps {
    variant: 'large' | 'small';
    title?: string;
    text?: string;
    icon?: PictureProps;
}

export default function CardIcon({
    variant,
    title,
    text,
    icon,
}: CardIconProps) {
    return (
        <>
            <CardBase
                className={cls(
                    'rounded-large bg-background-secondary p-lg flex flex-col',
                    {
                        'gap-96 md:gap-120 xl:gap-[160px] h-auto min-h-[360px] md:min-h-[396px] xl:min-h-[432px]':
                            variant === 'large',
                    },
                    {
                        'md:flex-row md:items-start gap-xxl':
                            variant === 'small',
                    },
                )}>
                {icon && (
                    <img
                        src={icon}
                        alt="Icon"
                        className="w-48 md:w-56 h-auto"
                    />
                )}
                <div className="flex-1">
                    {!!title && (
                        <Title
                            component="h4"
                            className="text-h400 text-text-primary">
                            {title}
                        </Title>
                    )}
                    {!!text && (
                        <Text
                            isHtml
                            component="p"
                            className="text-b300 text-text-secondary pt-sm">
                            {text}
                        </Text>
                    )}
                </div>
            </CardBase>
        </>
    );
}
